import { createClient } from "@supabase/supabase-js";
// Types générés disponibles pour référence, mais pas appliqués strictement pour l'instant
// import type { Database } from "../types/database";

// Validation des variables d'environnement au démarrage
function requireEnv(name: string): string {
  const value = import.meta.env[name];
  if (value == null || String(value).trim() === "") {
    throw new Error(
      `Variable d'environnement manquante ou vide : ${name}. Vérifiez votre fichier .env`
    );
  }
  return String(value);
}

const supabaseUrl = requireEnv("VITE_SUPABASE_URL");
const supabaseAnonKey = requireEnv("VITE_SUPABASE_ANON_KEY");

// TODO: Réactiver le typage strict après correction des incompatibilités
// export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export { supabaseUrl };
